export interface ITranslation {
    getMessage(messageName: string, substitutions?: any): string;
    getCurrentLanguage(): string;
}
